import { ref, onMounted, onUnmounted } from 'vue'

export const ScreenSize = Object.freeze({
  MOBILE: 'mobile',
  TABLET: 'tablet',
  PC: 'pc'
})

export function useScreenSize() {
  const currentScreenSize = ref(ScreenSize.PC)

  const checkScreenSize = () => {
    const width = window.innerWidth
    if (width < 768) {
      currentScreenSize.value = ScreenSize.MOBILE
    } else if (width >= 768 && width < 1024) {
      currentScreenSize.value = ScreenSize.MOBILE
      //currentScreenSize.value = ScreenSize.TABLET
      //tablet responsive i yapılana kadar tablet ekranlarında da mobile çıksın
    } else {
      currentScreenSize.value = ScreenSize.PC
    }
  }

  onMounted(() => {
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize)
  })

  // 👇 enum ve değer birlikte dönüyor
  return {
    currentScreenSize,
    ScreenSize
  }
}
